import type { CanonicalizationFilter, FileStatus } from '@/graphql/files';

/**
 * What the harness can narrow on, kept as one plain object so the container
 * owns a single piece of state and this component stays tellable through props.
 *
 * There is deliberately no owner control. The portal shows the signed-in
 * person's own files and the container pins `createdById` to them, so an owner
 * a reader could type would be a way to widen the page past what it is meant
 * to show rather than a filter. Keystone's `files` can still answer for
 * anyone; this surface does not ask it to.
 *
 * `canonicalized` and `canonicalization` are two controls over one dimension
 * each rather than one over both, because their *disagreement* is the row
 * worth finding: a COMPLETE job with no canonical is a rejection verdict, not
 * a wait, and one merged dropdown could not express the pair.
 */
export interface FileFilters {
  status: FileStatus | '';
  extAppApiId: string;
  appApiRef: 'any' | 'present' | 'absent';
  origin: 'any' | 'migrated' | 'uploaded';
  canonical: 'any' | 'present' | 'absent';
  canonicalization: CanonicalizationFilter | '';
}

export const EMPTY_FILTERS: FileFilters = {
  status: '',
  extAppApiId: '',
  appApiRef: 'any',
  origin: 'any',
  canonical: 'any',
  canonicalization: '',
};
